import './style.css'


function Chip({ children, type='success' }) {
    const chipClassName = type ? `chip chip-${type}` : 'chip';
    return (
        <div className={chipClassName}>
            <span>{children}</span>
        </div>
    )
}

export default Chip
